import React, { useState } from 'react';

import ChipRail from '../ChipRail/ChipRail';
import css from './SelectedPills.module.css';

const CloseIcon = () => (
  <svg
    className={css.pillClose}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 6l12 12M6 18L18 6" />
  </svg>
);

const SelectedPills = ({ pills, onRemove }) => {
  /* P25009-486 BR-2 — the car's technical conditions (ET, navhål, bultar,
   * bultcirkel…) are one "Passformsfilter (n)" chip; it opens to show them,
   * each still removable on its own. */
  const [fitGroupOpen, setFitGroupOpen] = useState(false);
  if (!pills?.length) return null;

  const plainPills = pills.filter(pill => pill.group !== 'fit');
  const fitPills = pills.filter(pill => pill.group === 'fit');

  const removablePill = (pill, index) => (
    <button
      type="button"
      key={`${pill.key}-${pill.value}-${index}`}
      className={css.pill}
      onClick={() => onRemove(pill)}
      aria-label={`Ta bort filter: ${pill.label}`}
    >
      <span className={css.pillLabel}>{pill.label}</span>
      <CloseIcon />
    </button>
  );

  /* One fixed-height rail regardless of how many filters are active
   * (P25009-453 BR-1/AC-1) — the chips scroll sideways instead of
   * wrapping onto new rows. */
  return (
    <ChipRail className={css.pillsWrap} ariaLabel="Aktiva filter">
      {plainPills.map(removablePill)}
      {fitPills.length > 0 ? (
        <button
          type="button"
          key="fitGroup"
          className={css.groupPill}
          onClick={() => setFitGroupOpen(open => !open)}
          aria-expanded={fitGroupOpen}
        >
          <span className={css.pillLabel}>Passformsfilter ({fitPills.length})</span>
          <span className={css.groupChevron} aria-hidden="true">
            {fitGroupOpen ? '▴' : '▾'}
          </span>
        </button>
      ) : null}
      {fitGroupOpen ? fitPills.map(removablePill) : null}
    </ChipRail>
  );
};

export default SelectedPills;
